import { move } from "utils/legacyArrayUtils";

export const getContentOnDragEnd = ({ content, source: { index: oldIndex }, destination: { index: newIndex } }) =>
  move(content, oldIndex, newIndex).map((item, index) => ({
    ...item,
    index,
  }));
